export const eeaCountries = [
  {
    value: 'geo-783754',
    label: 'Albania',
    group: ['EEA32', 'EEA33', 'EEA39', 'Pan-Europe'],
  },
  {
    value: 'geo-2782113',
    label: 'Austria',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-2802361',
    label: 'Belgium',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-3277605',
    label: 'Bosnia and Herzegovina',
    group: ['EFTA4', 'Pan-Europe'],
  },
  {
    value: 'geo-732800',
    label: 'Bulgaria',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU27', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-3202326',
    label: 'Croatia',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-146669',
    label: 'Cyprus',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU25', 'EU27', 'Pan-Europe'],
  },
  {
    value: 'geo-3077311',
    label: 'Czechia',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU25',
      'EU27',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-2623032',
    label: 'Denmark',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU15', 'EU25', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-453733',
    label: 'Estonia',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU25', 'EU27', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-660013',
    label: 'Finland',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-3017382',
    label: 'France',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-2921044',
    label: 'Germany',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-390903',
    label: 'Greece',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-719819',
    label: 'Hungary',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU25', 'EU27', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-2629691',
    label: 'Iceland',
    group: ['EEA32', 'EEA33', 'EEA39', 'EFTA4', 'Pan-Europe'],
  },
  {
    value: 'geo-2963597',
    label: 'Ireland',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-3175395',
    label: 'Italy',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-831053',
    label: 'Kosovo (UNSCR 1244/99)',
    group: ['EEA32', 'EEA33', 'EEA39'],
  },
  {
    value: 'geo-458258',
    label: 'Latvia',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU25', 'EU27', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-3042058',
    label: 'Liechtenstein',
    group: ['EEA32', 'EEA33', 'EEA39', 'EFTA4', 'Pan-Europe'],
  },
  {
    value: 'geo-597427',
    label: 'Lithuania',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU25', 'EU27', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-2960313',
    label: 'Luxembourg',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-2562770',
    label: 'Malta',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU25', 'EU27', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-3194884',
    label: 'Montenegro',
    group: ['EEA32', 'EEA33', 'EEA39', 'Pan-Europe'],
  },
  {
    value: 'geo-2750405',
    label: 'Netherlands',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-718075',
    label: 'North Macedonia',
    group: ['EEA32', 'EEA33', 'EEA39', 'Pan-Europe'],
  },
  {
    value: 'geo-3144096',
    label: 'Norway',
    group: ['EEA32', 'EEA33', 'EEA39', 'EFTA4', 'Pan-Europe'],
  },
  {
    value: 'geo-798544',
    label: 'Poland',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU25', 'EU27', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-2264397',
    label: 'Portugal',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-798549',
    label: 'Romania',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU27', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-6290252',
    label: 'Serbia',
    group: ['EEA32', 'EEA33', 'EEA39', 'Pan-Europe'],
  },
  {
    value: 'geo-3057568',
    label: 'Slovakia',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU25', 'EU27', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-3190538',
    label: 'Slovenia',
    group: ['EEA32', 'EEA33', 'EEA39', 'EU25', 'EU27', 'EU28', 'Pan-Europe'],
  },
  {
    value: 'geo-2510769',
    label: 'Spain',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-2661886',
    label: 'Sweden',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
  {
    value: 'geo-2658434',
    label: 'Switzerland',
    group: ['EEA32', 'EEA33', 'EEA39', 'EFTA4', 'Pan-Europe'],
  },
  {
    value: 'geo-298795',
    label: 'Turkey',
    group: ['EEA32', 'EEA33', 'EEA39', 'Pan-Europe'],
  },
  {
    value: 'geo-2635167',
    label: 'United Kingdom',
    group: [
      'EEA32',
      'EEA33',
      'EEA39',
      'EU15',
      'EU25',
      'EU27',
      'EU28',
      'Pan-Europe',
    ],
  },
];

export const countryGroups = [
  { label: 'EEA32', value: 'EEA32' },
  { label: 'EEA33', value: 'EEA33' },
  { label: 'EEA39', value: 'EEA39' },
  { label: 'EFTA4', value: 'EFTA4' },
  { label: 'EU15', value: 'EU15' },
  { label: 'EU25', value: 'EU25' },
  { label: 'EU27', value: 'EU27' },
  { label: 'EU28', value: 'EU28' },
  { label: 'Pan-Europe', value: 'pan-europe' },
];
